import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as featureActions from '@core-lib/store/init-store/actions';
import { switchMap, withLatestFrom } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { EMPTY, of } from 'rxjs';
import { StoreState } from '@store/store-state';
import { SharedStoreActions } from '@core-lib/store/shared-store';

@Injectable()
export class InitStoreEffects {
	constructor(private actions$: Actions, private store$: Store<StoreState>) {}

	initStart$ = createEffect(() =>
		this.actions$.pipe(
			ofType(featureActions.InitStart),
			withLatestFrom(this.store$),
			switchMap(([action, store]) => [SharedStoreActions.InitLanguages()])
		)
	);

	// TODO: Delete Or replace with real init check
	// Previously depended on validators which are now removed
	checkInitEnd$ = createEffect(() =>
		this.actions$.pipe(
			ofType(SharedStoreActions.InitLanguages),
			withLatestFrom(this.store$),
			switchMap(([_, store]) => {
				// add pre-user additional checks here
				return [featureActions.InitEnd()];
			})
		)
	);
}
